import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Observable, Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {
  CommentType,
  DocumentEditorType,
  DocumentPermission,
  IconType,
  IoniconsFilled,
  IoniconsOutline,
  LoggedUser,
  PtPermissions
} from '@pt/pt-models';
import {DpiaCommentsService} from '@pt/api-client';
import {ListTreatDpiaComment} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/ListTreatDpiaComment";
import {TreatDpiaComment} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/TreatDpiaComment";
import {
  CreateTreatDpiaCommentRequest
} from "it/primatoo/openapi/api/org/schemas/treatmentcomment/CreateTreatDpiaCommentRequest";
import { DocumentPermissionService, PtCoreSelectors } from '@pt/pt-core';

/**
 * ATTENZIONE: questo componente è usato anche all'interno dell'editor della DPIA,
 * Li il suo funzionamento è corretto, se utilizzato altrove o clonarlo o evitare di modificare il comportamento nell'editor
 * nota di @giovanni
 */
@Component({
  selector: 'pt-dpia-comments',
  template: `
    <ng-template
      *ngIf='show; then commentsAvailable; else noCommentsAvailable'></ng-template>

    <ng-template #commentsAvailable>
      <div [ngClass]='containerCssClass'>
        <button class='btn btn-sm btn-info w-100' (click)='open(content)'>
          <pt-icon [key]='IconStatsComment' [iconType]='IconType.IONIC_ICON' [size]='14'></pt-icon>
          <span>{{ 'MESSAGE.AVAILABLE_COMMENTS' | translate }}
            <!--            <span *ngIf='document?.comments[CommentType.ASSESSMENT]'-->
            <!--            >({{document?.comments[CommentType.ASSESSMENT]}})</span>-->
          </span>
        </button>
      </div>
    </ng-template>

    <ng-template #noCommentsAvailable>
      <pt-no-available-comments></pt-no-available-comments>
    </ng-template>

    <ng-template #content>
      <div class='modal-header'>
        <h4 class='modal-title' id='modal-basic-title'>
          {{ 'TITLE.AVAILABLE_COMMENTS' | translate }}
        </h4>
        <button type='button' class='btn-close' aria-label='Close' (click)='closeDialog()'>
        </button>
        <!--        <button type='button' class='close' aria-label='Close' (click)='closeDialog()'>-->
        <!--          <span aria-hidden='true'>&times;</span>-->
        <!--        </button>-->
      </div>
      <div class='modal-body modal-body--dpia-comment'>
        <ng-container>
          <form class='comments-write-area'
                [formGroup]='formGroup' *ngIf='formGroup'>
            <div class='w-100'>
            <textarea
              rows='4'
              style="border-radius:0"
              class='form-control'
              formControlName='comment'
            ></textarea>
            </div>

            <div class='d-flex justify-content-end mt-2'>
              <pt-button-with-loader
                [loading]='loading'
                [disabled]='formGroup?.invalid || !dpiaCommentBtnEnabled'
                [cssClass]='"btn btn-sm btn-success"'
                [label]='"BUTTON.SEND_EVALUATION" | translate'
                (buttonWithLoaderClick)='sendComment()'
              ></pt-button-with-loader>
            </div>
          </form>
        </ng-container>

        <div class='comments-view-area h-100'
             *ngIf='loginResponse$ | async as loginResponse'>
          <ng-container *ngIf='dpiaComments?.length else NO_MESSAGES'>
            <ng-container *ngFor='let c of dpiaComments; index as i'>
              <div class='card' [ngClass]='{"mt-3": i > 0}' style='background-color: #e9e9e9'>
                <div class='comment-container'>
                  <div class='comment-header'>
                    <pt-icon [key]='IconUser' [iconType]='IconType.IONIC_ICON' [size]='40'></pt-icon>
                    <div class='d-flex flex-column'>
                      <div class='fw-bold' style='color: #505050'>{{ c?.authorUsername }}</div>
                      <small class='text-muted'>{{ c?.createdAt | localizedDate }}</small>
                    </div>
                    <div class='dpia-comment-delete-confirm'
                         *ngIf='loginResponse?.id === c?.authorId || loginResponse?.system'>
                      <pt-delete-with-confirm
                        class="display-contents"
                        [disabled]="!dpiaCommentBtnEnabled"
                        [loading]='loading'
                        [confirmMessage]='"MESSAGE.COMMENT_DELETE" | translate'
                        (clickConfirmDelete)='deleteComment(c?.id)'
                      ></pt-delete-with-confirm>
                    </div>
                  </div>

                  <div class='comment-body' [innerHTML]='c?.comment | formatNewlineToHtml'></div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #NO_MESSAGES>
            <div class='h5 text-muted no-comments'>
              <pt-icon [key]='IconStatsComment'
                       [iconType]='IconType.IONIC_ICON'
                       [size]='23'>
              </pt-icon>
              <span>{{ "MESSAGE.NO_EVALUATIONS" | translate }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
  `,
  styles: [`

    .dpia-comment-delete-confirm {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      height: 100%;
      align-items: flex-start;
      justify-content: flex-end;
    }

    .modal-body--dpia-comment {
      padding: 0;
      /*overflow-y: auto;*/
      /*max-height: 600px;*/
      /*height: calc(100vh - 128px);*/
    }

    .comments-write-area {
      min-height: 25%;
      padding: 15px;
      border-bottom: solid 1px var(--ptBorder);
    }

    .comments-view-area {
      padding: 15px;
      /*max-height: 75%;*/
      overflow-y: auto;
      max-height: 300px;
      overflow-y: auto;
    }

    .full-height {
      max-height: none;
    }

    .comment-container {
      padding: 8px;
      background: #e9f2fa;
    }

    .comment-header {
      display: flex;
    }

    .comment-body {
      padding: 0 5px;
      margin: 5px 0 0 0;
    }

    .no-comments {
      margin: 0;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class DpiaCommentsComponent implements OnInit, OnDestroy, OnChanges {

  @Input() docId: number;
  // @Input() document: DpiaEditable;
  @Input() containerCssClass: string;

  @Output() reloadDocument = new EventEmitter;

  public loginResponse$: Observable<LoggedUser> = this.store.select(PtCoreSelectors.loginResponse);

  public show: boolean;

  public IconType = IconType;
  public IconStatsComment = IoniconsOutline.commentSquare;
  public IconUser = IoniconsFilled.userCircle;

  public CommentType = CommentType;

  public dpiaComments: Array<TreatDpiaComment> = [];
  public formGroup: FormGroup;

  public PtPermissions = PtPermissions;

  public loading = false;
  public dpiaCommentBtnEnabled = false;
  private currentDialog;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store,
    private modalService: NgbModal,
    private documentPermission: DocumentPermissionService,
    private dpiaCommentsService: DpiaCommentsService
  ) {
  }

  open(content) {
    this.documentPermission.getDocumentPermission(DocumentEditorType.TREATMENT, this.docId).subscribe((s: DocumentPermission) => {
      this.dpiaCommentBtnEnabled = s.dpiaCommentBtnEnabled;
      if (this.dpiaCommentBtnEnabled) {
        this.formGroup.enable()
      } else {
        this.formGroup.disable()
      }
      this.currentDialog = this.modalService.open(content, {
        centered: true,
        keyboard: false,
        backdrop: 'static',
        size: 'lg'
      });
    })

  }

  ngOnDestroy(): void {
    this.closeDialog();
    this.destroy$.next(true);
  }

  ngOnInit() {
    this.loading = false;
    this.reset();

    this.dpiaCommentsService.getComments(this.docId).pipe(
      takeUntil(this.destroy$)
    ).subscribe((response: ListTreatDpiaComment) => {
      this.dpiaComments = response.comments || [];
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.show = false;
    setTimeout(() => this.show = true);

    this.reset();
  }

  reset() {
    this.dpiaComments = [];
    if (this.formGroup) {
      this.formGroup.reset();
    } else {
      this.formGroup = new FormGroup({
        comment: new FormControl(null, [Validators.required])
      });
    }
  }

  sendComment() {
    this.loading = true;

    const request: CreateTreatDpiaCommentRequest = {
      comment: this.formGroup.controls.comment.value,
    };

    this.dpiaCommentsService.createComment(this.docId, request).subscribe(() => {
      this.ngOnInit();
    }, () => this.loading = false);
  }

  deleteComment(commentId: number) {
    this.loading = true;
    this.dpiaCommentsService.deleteComment(this.docId, commentId).subscribe(() => {
      this.ngOnInit();
    }, () => this.loading = false);
  }

  closeDialog() {
    if (this.currentDialog) {
      this.currentDialog.close();
      this.reloadDocument.emit();
    }
  }
}
